import { DataGridProps, GridPaginationModel } from '@mui/x-data-grid'
import { useState } from 'react'

export default function useDataGrid({
  paginationModel,
  pageSizeOptions,
  onPaginationModelChange,
  ...props
}: Partial<DataGridProps> = {}): Partial<DataGridProps> {
  const [defaultPaginationModel, setDefaultPaginationModel] = useState<GridPaginationModel>({
    pageSize: 24,
    page: 0
  })

  const defaultPageSizeOptions = [12, 24, 48, 96]

  function handlePaginationModelChange(model: GridPaginationModel) {
    setDefaultPaginationModel(model)
  }

  return {
    paginationModel: paginationModel ?? defaultPaginationModel,
    pageSizeOptions: pageSizeOptions ?? defaultPageSizeOptions,
    onPaginationModelChange: onPaginationModelChange ?? handlePaginationModelChange,
    ...props
  }
}
